import { useEffect } from "react";

const PageWrapper = ({ title, children }) => {
  useEffect(() => {
    document.title = title ? `${title} | DirectSubmit` : "DirectSubmit";
  }, [title]);

  return children;
};

export default PageWrapper;